import { useSelector } from 'react-redux'
import { useState, useEffect } from "react";
import { Grid } from '@mui/material';
import { gridSpacing } from '../../store/constant';
import StickyHeadTable from '../components/StickyHeadTable';
import axios from "../../components/axios";
import { useNavigate } from 'react-router-dom';


const columns = [
  { id: 'name', label: 'Email', minWidth: 200 , align: 'left'},
  { id: 'role', label: 'Role', align: 'center'},
  { id: 'last_login', label: 'Last Login', align: 'center'},
  { id: 'action', label: 'Edit', align: 'center', action: true},
];

const UserListPage = () => {
    const customization = useSelector((state) => state.customization);
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);

    useEffect(() => {
        const getUserList = async () => {
            try {
                const response = await axios.post("/peloton/v1/users/all-user", null, { withCredentials: true});
                if (response.data.message === "success"){
                    setRows(response.data.users);
                }
            } catch (error) {
                if (error.response.status !== null){
                    if (error.response.status === 401){
                        alert(error.response.data.message);
                        navigate("/");
                    }else{
                        console.log('error.response.status: ', error.response.status)
                        console.log('error.response.message: ', error.response.data.message)
                    }
                }else{
                    console.log(error);
                }
            }
        };
        getUserList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleEdit = (uuid) => {
        navigate('/modify-user/'+uuid);
    };

    const handleDelete = (uuid) => {
        var input_data = JSON.stringify({ uuid: uuid });
        axios.post("/peloton/v1/users/remove-user",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
                alert(response.data.message);
                window.location.href = '/#/user-list';
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
            if (!err.response){
                alert(err);
            }else{
                if (err.response.status === 401){
                    alert(err.response.data.message);
                    navigate("/");
                }else{
                    console.log('error.response.status: ', err.response.status)
                    console.log('error.response.message: ', err.response.data.message)
                    alert(err.response.data.message)
                }
            }
        })
    };

    return (
        <Grid container spacing={gridSpacing} alignItems="center" sx={{ marginTop: "40px"}}>
            <Grid item xs={12} >
                {customization.login && (<StickyHeadTable rows={rows} columns={columns} handleEdit={handleEdit} handleDelete={handleDelete} title="QBarn User List"/>)}
            </Grid>
        </Grid>
    );
};

export default UserListPage;